import BaseField from './BaseField';
import BooleanField from './BooleanField';
import EmailField from './EmailField';
import SelectField from './SelectField';
import TypeFactory from './TypeFactory';
import UrlField from './UrlField';

export const types = {
  BaseField,
  BooleanField,
  EmailField,
  SelectField,
  TypeFactory,
  UrlField,
};
